import { PersonalCardScreenNavigationProps } from "./types"
import React, { useEffect } from "react"
import { ActivityIndicator } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import PersonalCard from "./personal-card-screen"
import { canViewUserProfile, parseUserId } from "./access"
import { useStores } from "~models"
import useNavigation from "~hooks/useNavigation"
import { useLocation } from "~router/navigation"
import { CenterFlex, Text } from "~components/El"
import { globalToast } from "~utils"
import { PageRoot } from "~screens/page-root"


const PersonalCardScreen: React.FC<PersonalCardScreenNavigationProps> = observer(function PersonalCardScreen() {
  const rootStore = useStores()
  const navigation = useNavigation()
  const location = useLocation()
  const stateUserId = parseUserId((location.state as { userId?: unknown } | null)?.userId)
  const isSendMessageButtonVisible =
    (location.state as { isSendMessageButtonVisible?: boolean } | null)?.isSendMessageButtonVisible ?? true

  const allowed = stateUserId != null && canViewUserProfile(stateUserId, rootStore)

  useEffect(() => {
    if (stateUserId == null) {
      globalToast.show("请从应用内入口打开用户资料")
      navigation.goBack()
      return
    }
    if (!canViewUserProfile(stateUserId, rootStore)) {
      globalToast.show("无权查看该用户资料")
      navigation.goBack()
    }
  }, [stateUserId, rootStore, navigation])

  if (stateUserId == null) {
    return (
      <PageRoot>
        <CenterFlex flex={1}>
          <Text color="secondaryText">无效的访问方式</Text>
        </CenterFlex>
      </PageRoot>
    )
  }

  if (!allowed) {
    return (
      <PageRoot>
        <CenterFlex flex={1}>
          <ActivityIndicator />
        </CenterFlex>
      </PageRoot>
    )
  }

  return (
    <PageRoot>
      <PersonalCard userId={stateUserId} isSendMessageButtonVisible={isSendMessageButtonVisible} />
    </PageRoot>
  )
})

export default PersonalCardScreen
